import { Box, Popover } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Text from 'commons/Text';

import useStyles from './styles';

const ShareLinkSelectionDialog = ({ open, anchorEl, onClose, onNext, onShareMyPage }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const handleChooseShareMyPage = () => {
    if (!onShareMyPage) {
      return;
    }

    onShareMyPage();
  };

  const handleChooseShareSelected = () => {
    onNext?.({
      artworks: [],
      exhibitions: [],
    });
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      PaperProps={{ className: classes.popoverPaper }}
    >
      <Box className={classes.choiceContainer}>
        <Box
          role="button"
          tabIndex={0}
          onClick={handleChooseShareMyPage}
          className={classes.choiceRow}
        >
          <Text className={classes.choiceTitle}>{t('share_my_page')}</Text>
          <Text className={classes.choiceSubtitle}>{t('share_my_page_desc')}</Text>
        </Box>

        <Box
          role="button"
          tabIndex={0}
          onClick={handleChooseShareSelected}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') handleChooseShareSelected();
          }}
          className={classes.choiceRow}
        >
          <Text className={classes.choiceTitle}>{t('share_selected_artworks')}</Text>
          <Text className={classes.choiceSubtitle}>{t('share_selected_artworks_desc')}</Text>
        </Box>
      </Box>
    </Popover>
  );
};

export default ShareLinkSelectionDialog;
